import supportedAddonProducts from "lib/supportedAddonProducts";

const getAddonProductPrice = (api, product) => {
  return api.getAddonProductPrice(product).then(
    (data) => data.result,
    (err) => {
      console.error("Get addon product price failed", err);
      return false;
    },
  );
};

export const getPricesForUpsellAddonProducts =
  (upsellProducts) =>
  async (dispatch, getState, { api }) => {
    const addonProductPrices = [];

    for (const product of upsellProducts) {
      // Check that we support displaying the addon product
      if (supportedAddonProducts.indexOf(product) !== -1) {
        // Get the price
        const addonProductPrice = await getAddonProductPrice(api, product);

        // For Sitelock Lite, the renewalprice is another addon product. Get that price.
        if (product === "SITELOCK_LITE") {
          const sitelockFindPrice = await getAddonProductPrice(
            api,
            "SITELOCK_FIND",
          );

          addonProductPrice.renewalPriceInclVatAsString =
            sitelockFindPrice.renewalPriceInclVatAsString;
          addonProductPrice.renewalPriceExclVatAsString =
            sitelockFindPrice.renewalPriceExclVatAsString;
        }

        //responseData.addonProductPrices[product] = addonProductPrice;
        addonProductPrices[product] = addonProductPrice;
      }
    }

    return addonProductPrices;
  };
